export enum IDCardSide {
    FRONT = "front",
    BACK = "back"
}